import { memo } from "react";
import { useAtom } from 'jotai';
import { userInformationAtom } from "~/stores/UserStore";
import { Avatar as AntdAvatar } from "antd";
import { getHashColor } from "~/utils/hashStringUtil";
import styled from "styled-components";
import { UserOutlined } from "@ant-design/icons";
import { User_Base } from "~/common/typescript/models/User";

export interface UserAvatarProps {
  user: User_Base;
  size?: number | 'small' | 'default' | 'large';
  style?: React.CSSProperties;
}
const UserAvatar = (props: UserAvatarProps) => {
  let { backgroundColor, foregroundColor } = { ...getHashColor(props.user.username) };

  return (
    <AntdAvatar
      size={props.size || 'default'}
      style={{
        backgroundColor: backgroundColor,
        color: foregroundColor,
        userSelect: 'none',
        cursor: 'pointer',
        border: '1px solid #ccc',
        fontSize: typeof props.size === 'number' && props.size < 28 ? 10 : undefined,
        ...props.style,
      }}
    >
      {(props.user.fullname || props.user.username || '').slice(0, 2).toUpperCase()}
    </AntdAvatar>
  );
};

export default memo(UserAvatar);

const UI_Options_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 5px 0;
  min-width: 100px;
`

const UI_Options_Button = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 14px;
  &:hover {
    background-color: var(--color-primary);
    color: white;
  }
  &.active {
    background-color: var(--color-primary);
    color: white;
  }
`